import Lottie from "lottie-react";
import { useState } from "react";
import DeleteAnimation from "../../../assets/annimation/delete.json";

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  if (!isOpen) return null;

  const handleDelete = () => {
    setIsAnimating(true);
    setTimeout(() => {
      onConfirm();
      setIsAnimating(false);
      onClose();
    }, 2000);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-1/3 flex flex-col items-center">
        {isAnimating ? (
          <div className="h-40 w-40">
            <Lottie animationData={DeleteAnimation} />
          </div>
        ) : (
          <>
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-200 rounded-full">
                <span className="text-orange-500 text-4xl font-bold">?</span>
              </div>
            </div>
            <h2 className="text-xl font-inter text-center">Delete Selected Data Permanently?</h2>
            <p className="text-gray-600 text-center mt-2">
              Are you sure you want to delete the selected data?
            </p>
            <div className="flex justify-between mt-6 w-full">
              <button
                className="bg-gray-400 text-white px-4 py-2 rounded w-1/2 mr-2"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                className="bg-orange-400 text-white px-4 py-2 rounded w-1/2 ml-2"
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmationModal;
